<template>
  <div>
    <el-dialog
      title="Insert Image"
      :visible="dialog"
      width="750px"
      top="3vh"
      :modal="true"
      :append-to-body="true"
      @close="setDialog(false)"
    >
      <UploadImage />
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import UploadImage from './UploadImage'

export default {
  components: {
    UploadImage
  },

  computed: {
    ...mapState('fileManager', [
      'loading',
      'directory',
      'dialog'
    ])
  },

  methods: {
    ...mapMutations('fileManager', [
      'setDialog'
    ])
  }
}
</script>
